const userFilters = {
  firstName: null,
  lastName: null,
  active: null,
  securityRoles: null,
  employeePayrollTypeId: null,
  businessEntityId: null,
  includeInactive: null
}

export default () => Object.assign({}, userFilters)
